import { render, staticRenderFns } from "./details-right.vue?vue&type=template&id=803ba232&scoped=true&"
import script from "./details-right.vue?vue&type=script&lang=ts&"
export * from "./details-right.vue?vue&type=script&lang=ts&"
import style0 from "./details-right.vue?vue&type=style&index=0&id=803ba232&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803ba232",
  null
  
)

export default component.exports